import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const LiveChat = () => {
  const [open, setOpen] = useState(false);

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 900, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
            variant="h4"
            sx={{
             fontWeight: 700,
             letterSpacing: "-0.02em",
             mb: 1,
            }}
        >
          Live Chat
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Connect with HaggleFreight support for load, account, payment, or
          platform assistance.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: 4,
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => setOpen(true)}
            sx={{
              px: 4,
              py: 1.4,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Start Live Chat
          </Button>
        </Paper>

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>HaggleFreight Support</DialogTitle>

          <DialogContent dividers>
            <Typography sx={{ mb: 2 }}>
               Send a message to HaggleFreight support. We will respond as soon as possible.
            </Typography>

            <TextField
              fullWidth
              multiline
              rows={5}
              placeholder="Type your message..."
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>
              Close
            </Button>

            <Button
              variant="contained"
              onClick={() => setOpen(false)}
            >
              Submit Request
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </CustomerLayout>
  );
};

export default LiveChat;
